import React from "react";
import { useLocation } from "react-router-dom";
import BookLink from "@/components/site/BookLink";

const FloatingBookButton = () => {
  const location = useLocation();
  // Hide on book/admin/checkin/login routes
  if (/^\/(book|admin|checkin|login|auth|waiver-qr)/.test(location.pathname)) return null;
  return (
    <BookLink
      data-testid="floating-book-btn"
      className="fixed right-0 top-1/2 -translate-y-1/2 z-40 [writing-mode:vertical-rl] [text-orientation:mixed] bg-spike-blue hover:bg-spike-blue-hover text-black font-orbitron font-bold uppercase tracking-[0.18em] py-6 px-3 rounded-l-md shadow-lg shadow-spike-blue/40"
    >
      <span className="tracking-wider text-sm">Book a Lane Now</span>
    </BookLink>
  );
};

export default FloatingBookButton;
